// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__NFwzY","swiper":"Carousel_swiper__ILaSI","logo":"Carousel_logo__ABf4I","slide":"Carousel_slide__d0xbX","gradient":"Carousel_gradient__pg8WS"};